/**
 * sub-cat.js
 * JavaScript for handling responsive classes and initializing Swiper for sub-category filtering.
 */
import Swiper from "swiper/bundle";

/**
 * handleResponsiveClasses
 * Handles responsive classes for sub-category filtering.
 */
function handleResponsiveClasses() {
  /**
   * Toggle class based on window width.
   * @param {string} selector - The CSS selector for the element.
   * @param {string} className - The class name to toggle.
   * @param {boolean} condition - The condition to toggle the class.
   */
  function toggleClassByWidth(selector, className, condition) {
    const element = document.querySelector(selector);
    if (!element) return;

    element.classList.toggle(className, condition);
  }

  // Hide sub-category filtering on desktop
  toggleClassByWidth(".sub-cat-filter", "cat-hidden", window.innerWidth < 992);

  // Hide mobile product category on desktop
  toggleClassByWidth(
    '[data-attr-id="mobile-product-cat"]',
    "hidden-mobile-cat",
    window.innerWidth > 992
  );
}

function toggleClassByWidth(selector, className, condition) {
  const element = document.querySelector(selector);
  if (!element) return;

  element.classList.toggle(className, condition);
}

function initSwiper() {
  const swiperContainer = document.querySelector(".sub-cat-filter__swipper");
  if (!swiperContainer) return;

  const swiperWrapper = swiperContainer.querySelector(".swiper-wrapper");
  if (
    swiperWrapper &&
    swiperWrapper.scrollWidth <= swiperContainer.offsetWidth
  ) {
    swiperWrapper.style.justifyContent = "center";
  }

  const swiper = new Swiper(swiperContainer, {
    slidesPerView: "auto",
    spaceBetween: 14,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initSwiper();
  handleResponsiveClasses();
});
/*******  228aeafd-ffa6-4363-b5bf-42047e95dc6d  *******/

window.addEventListener("resize", handleResponsiveClasses);
